import { RadioSwatchGroup_Field_default } from "./chunk-CMCE53X5.js";
import { RadioSwatchGroup_default } from "./chunk-FZKQOQZY.js";
import { RadioSwatchGroup_MoreButton_default } from "./chunk-UQJQUVJV.js";

// src/components/RadioSwatchGroup/index.ts
var RadioSwatchGroupComponent = RadioSwatchGroup_default;
RadioSwatchGroupComponent.Field = RadioSwatchGroup_Field_default;
RadioSwatchGroupComponent.Field.displayName = "RadioSwatchGroup.Field";
RadioSwatchGroupComponent.MoreButton = RadioSwatchGroup_MoreButton_default;
RadioSwatchGroupComponent.MoreButton.displayName = "RadioSwatchGroup.MoreButton";
export { RadioSwatchGroupComponent };